<template>
  <div
    v-if="metric"
    class="lucy-nudge"
  >
    <span class="lucy-nudge__avatar">L</span>
    <div class="lucy-nudge__text">
      <strong>{{ $t('lucy.nudgeTitle') }}</strong>
      <span>{{ $t('lucy.nudgeBody', [$t('seoScore.' + metric + '.label')]) }}</span>
    </div>
    <v-btn
      x-small
      depressed
      class="text-none"
      color="ai"
      dark
      @click="go"
    >
      {{ $t('lucy.goThere') }}
    </v-btn>
    <v-btn
      x-small
      outlined
      class="text-none"
      color="ai"
      @click="ask"
    >
      {{ $t('lucy.ask') }}
    </v-btn>
  </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import {SeoScoreMetricName, seoScoreMetricNames, SeoScoreStatus} from '@/model/SeoScore';
    import SeoScoreMetricsMixin from '@/mixins/SeoScoreMetricsMixin';
    import {firstAiVisibilityGap, lucyMetricIsDone, openLucyPanel} from '@/service/lucyCoach';
    import {focusSeoMetric} from '@/service/seoScoreFocus';

    type NudgeVm = Vue & {
        getStatus(name: SeoScoreMetricName): SeoScoreStatus;
    };

    export default Vue.extend({
        name: 'LucyNudge',
        mixins: [SeoScoreMetricsMixin],
        computed: {
            metric(): SeoScoreMetricName | null {
                if (this.$store.getters.sharePreview || !this.$store.getters.article.id) {
                    return null;
                }
                const vm = this as unknown as NudgeVm;
                const article = this.$store.getters.article;
                if (!lucyMetricIsDone('aiVisibility', vm.getStatus('aiVisibility'), article)) {
                    return firstAiVisibilityGap(article) || 'faqPresent';
                }
                return seoScoreMetricNames.find((name) => {
                    return name !== 'aiVisibility' && !lucyMetricIsDone(name, vm.getStatus(name), article);
                }) || null;
            }
        },
        methods: {
            go(): void {
                if (this.metric) {
                    focusSeoMetric(this.metric);
                }
            },
            ask(): void {
                openLucyPanel({question: 'next'});
            }
        }
    });
</script>

<style scoped lang="sass">
.lucy-nudge
    display: flex
    flex-wrap: wrap
    align-items: center
    gap: 10px
    background: rgba(205, 126, 194, 0.12)
    border: 1px solid rgba(205, 126, 194, 0.35)
    border-radius: 12px
    padding: 10px 12px
    margin: 8px 0 4px

.lucy-nudge__avatar
    width: 28px
    height: 28px
    border-radius: 50%
    background: linear-gradient(135deg, #cd7ec2, #8e3d82)
    color: #fff
    font-weight: 800
    display: inline-flex
    align-items: center
    justify-content: center
    flex: 0 0 28px

.lucy-nudge__text
    flex: 1 1 180px
    display: flex
    flex-direction: column
    font-size: 13px
    line-height: 1.35

    strong
        font-size: 12px
</style>
